import { defineMessages } from 'react-intl';

export default defineMessages({
    noCoverage: {
        id: 'eapolicychange.bop.directives.bop-building-directive.No Coverages',
        defaultMessage: 'No Coverages'
    },
    selectedValue: {
        id: 'eapolicychange.The value must be between',
        defaultMessage: 'The value must be between {minValue} and {maxValue}'
    },
    minValue: {
        id: 'eapolicychange.The minimum allowed value is',
        defaultMessage: 'The minimum allowed value is {minValue}'
    },
    maxValue: {
        id: 'eapolicychange.The maximum allowed value is',
        defaultMessage: 'The maximum allowed value is {maxValue}'
    },
    updatingSelection: {
        id: 'eapolicychange.directives.coverages.Updating selection...',
        defaultMessage: 'Updating selection...'
    }
});
